import { makeAutoObservable, set } from "mobx"


// Mime les status d'une map Haxe
export const STATUS = {
    locked: "locked",
    locked_open: "locked_open",
    open: "open",
    done: "done",
}

class Item {
    id = null
    title = null
    infos = null
    image = null
    cost = null
    vue = null

    blockRef = null

    status = STATUS.locked

    constructor(json, blockRef) {
        this.id = json.id
        this.title = json.title;
        this.infos = json.infos;
        this.image = json.image;
        this.vue = json.vue;
        this.cost = parseInt(json.cost);

        this.blockRef = blockRef

        makeAutoObservable(this)
    }

    get locked() {
        return this.status === STATUS.locked
    }

    get locked_open() {
        return this.status === STATUS.locked_open
    }

    get open() {
        return this.status === STATUS.open
    }

    get done() {
        return this.status === STATUS.done
    }

    get selected() {
        return this.blockRef.selectionRef.itemSelected.includes(this)
    }

    get active() {
        return this.blockRef.selectionRef.activeItem === this
    }
}

class Block {
    id = null
    title = null
    infos = null
    color = null
    borderColor = null

    items = []

    status = STATUS.locked

    selectionRef = null

    constructor(json, selectionRef) {
        this.id = json.id
        this.title = json.title;
        this.infos = json.infos;
        this.color = json.color;
        this.borderColor = json.borderColor;

        this.items = [];

        this.selectionRef = selectionRef

        makeAutoObservable(this)
    }

    addItem(item) {
        this.items.push(new Item(item, this));
    }

    get locked() {
        return this.status === STATUS.locked
    }

    get locked_open() {
        return this.status === STATUS.locked_open
    }

    get open() {
        return this.status === STATUS.open
    }

    get draggable() {
        return !this.items.some(i => i.status !== STATUS.done)
    }

    get interactive() {
        return this.status === STATUS.open && !this.items.some(i => i.status === STATUS.locked || i.status === STATUS.locked_open)
    }
}

class Selection {
    id = null
    title = null

    blocks = []

    points = 0
    basePoints = 0

    animDelay = 800 // time before done are called (allowing to make some css animations)

    itemSelected = []
    activeItem = null

    constructor(json) {
        this.id = json.id
        this.title = json.title
        this.basePoints = parseInt(json.cost)
        this.points = this.basePoints

        this.blocks = [];

        this.itemSelected = []
        this.activeItem = null

        makeAutoObservable(this)
    }

    addBlock(json) {
        this.blocks.push(new Block(json, this));
    }

    getItem(id) {
        return this.blocks.flatMap(b => b.items).find(i => i.id === id)
    }

    changeBlockStatus(id, status, onDone) {
        let b = this.blocks.find(b => b.id === id)
        if (b && b.status !== status) {
            const anim = `${b.status}_${status}`
            if (STATUS[anim]) {
                b.status = STATUS[anim]
            }

            setTimeout(() => {
                b.status = status

                if (onDone) onDone()
            }, this.animDelay/2)
        }
        else {
            if (onDone) onDone()
        }
    }

    changeItemStatus(id, status, onDone) {
        let item = null
        let block = null

        this.blocks.forEach(b => {
            b.items.forEach(i => {
                if (i.id === id) {
                    block = b
                    item = i
                }
            })
        })

        if (block && item) {
            if (item.status === status) {
                if (onDone) onDone()
            }
            else if (block.status === STATUS.locked) {
                this.changeBlockStatus(block.id, STATUS.open, () => this.changeItemStatus(id, status, onDone))
            }
            else {
                const anim = `${item.status}_${status}`
                if (STATUS[anim]) {
                    item.status = STATUS[anim]
                    setTimeout(() => {
                        item.status = status
                        if (onDone) onDone()
                    }, this.animDelay)
                }
                else {
                    item.status = status
                    if (onDone) onDone()
                }
            }
        }
    }
}

class SelectionPhase {

    selections = new Map()

    constructor() {
    }

    init(json) {
        var currentSelection = null

        json.forEach(element => {
            if (element.type === "main") {
                if (currentSelection) {
                    this.selections.set(currentSelection.id, currentSelection)
                    currentSelection = null
                }
                currentSelection = new Selection(element)
            }
            else if (element.type === "block") {
                currentSelection?.addBlock(element)
            }
            else if (element.type === "item" && currentSelection?.blocks.length > 0) {
                currentSelection.blocks[currentSelection.blocks.length - 1].addItem(element)
            }
        });

        if (currentSelection)
            this.selections.set(currentSelection.id, currentSelection)
    }

    get(id) {
        return this.selections.get(id)
    }

}

export default new SelectionPhase();